import React from 'react';
import './AppHeader.css';

interface AppHeaderProps {
  serverStatus: any;
  volume: number;
  isMuted: boolean;
  onVolumeChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onMuteToggle: () => void;
}

const AppHeader: React.FC<AppHeaderProps> = ({
  serverStatus,
  volume,
  isMuted,
  onVolumeChange,
  onMuteToggle
}) => {
  return (
    <header className="App-header">
      <h1>🏴‍☠️ Viking Ears</h1>
      <p>A tactical tabletop combat game</p>
      
      <div className="audio-controls">
        <label htmlFor="volume">Volume:</label>
        <input
          id="volume"
          type="range"
          min="0"
          max="1"
          step="0.1"
          value={volume}
          onChange={onVolumeChange}
        />
        <button onClick={onMuteToggle}>
          {isMuted ? '🔇' : '🔊'}
        </button>
      </div>
      
      <div className="server-status">
        {serverStatus ? (
          <span className="status-ok">✅ Server: {serverStatus.status}</span>
        ) : (
          <span className="status-error">❌ Server: Disconnected</span>
        )}
      </div>
    </header>
  );
};

export default AppHeader;